import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

// Smart API URL switching
const API_BASE_URL =
    window.location.hostname === "staging187611.digassistant.xyz"
        ? "https://api.digassistant.xyz"
        : window.location.hostname === "digassistant.xyz" || window.location.hostname === "www.digassistant.xyz"
            ? "https://api.digassistant.xyz"
            : "http://localhost:8080";

const PasswordlessLoginPage = () => {
    const navigate = useNavigate();
    const [isProcessing, setIsProcessing] = useState(false);
    const [email, setEmail] = useState("");
    const [formErrors, setFormErrors] = useState({});

    const validateForm = () => {
        const errors = {};

        if (!email) {
            errors.email = "Email is required";
        } else if (!/\S+@\S+\.\S+/.test(email)) {
            errors.email = "Email is invalid";
        }

        setFormErrors(errors);
        return Object.keys(errors).length === 0;
    };

    const handleInputChange = (e) => {
        const value = e.target.value;
        setEmail(value);
        if (formErrors.email) {
            setFormErrors(prev => ({
                ...prev,
                email: ""
            }));
        }
    };

    const handleFormSubmit = async (e) => {
        e.preventDefault();

        if (!validateForm()) {
            return;
        }

        setIsProcessing(true);
        setFormErrors({});

        try {
            const res = await fetch(`${API_BASE_URL}/auth/passwordless/request`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ email }),
                credentials: "include",
            });

            if (res.ok) {
                navigate("/verify", { state: { email } });
            } else {
                let errorMessage = "";
                try {
                    const errorData = await res.json();
                    errorMessage = errorData.error || "";
                    console.error("❌ Error:", errorMessage);
                } catch (e) {
                    console.error("❌ Failed to parse error response");
                }
                if (errorMessage) {
                    setFormErrors({ general: errorMessage });
                }
                setIsProcessing(false);
            }
        } catch (error) {
            console.error("❌ Error:", error);
            setFormErrors({ general: "Network error. Please try again." });
            setIsProcessing(false);
        }
    };

    if (isProcessing) {
        return (
            <div className="login-format" style={{ padding: "20px", textAlign: "center" }}>
                <div style={{ width: "fit-content", margin: "0 auto" }}>
                    <h1>Sending code...</h1>
                    <p>Please wait while we send your verification code.</p>
                </div>
            </div>
        );
    }

    return (
        <div className="login-format" style={{ padding: "20px", textAlign: "center" }}>
            <div style={{ width: "100%", maxWidth: "500px", margin: "0 auto", padding: "0 20px", boxSizing: "border-box" }}>
                <h1 style={{ fontSize: "clamp(20px, 5vw, 28px)", marginBottom: "30px" }}>Login or Sign Up</h1>

                <form onSubmit={handleFormSubmit} style={{ marginBottom: "20px" }}>
                    <div style={{ marginBottom: "15px", textAlign: "left" }}>
                        <label style={{ display: "block", marginBottom: "5px", fontWeight: "bold" }}>
                            Email:
                        </label>
                        <input
                            type="email"
                            name="email"
                            value={email}
                            onChange={handleInputChange}
                            style={{
                                width: "100%",
                                padding: "12px",
                                border: "1px solid #ccc",
                                borderRadius: "4px",
                                fontSize: "16px",
                                boxSizing: "border-box"
                            }}
                        />
                        {formErrors.email && (
                            <div style={{ color: "red", fontSize: "12px", marginTop: "2px" }}>
                                {formErrors.email}
                            </div>
                        )}
                    </div>

                    {formErrors.general && (
                        <div style={{ color: "red", fontSize: "12px", marginBottom: "10px" }}>
                            {formErrors.general}
                        </div>
                    )}

                    <button
                        type="submit"
                        disabled={isProcessing}
                        style={{
                            width: "100%",
                            background: 'none',
                            border: '1px solid #009e4a',
                            color: isProcessing ? "rgba(255, 255, 255, 0.5)" : '#009e4a',
                            padding: '14px 24px',
                            borderRadius: '5px',
                            cursor: isProcessing ? 'not-allowed' : 'pointer',
                            fontFamily: 'CustomFont',
                            fontSize: '16px',
                            transition: 'all 0.2s',
                            boxSizing: "border-box"
                        }}
                        onMouseOver={(e) => {
                            if (!isProcessing) {
                                e.target.style.background = '#009e4a';
                                e.target.style.color = 'black';
                            }
                        }}
                        onMouseOut={(e) => {
                            if (!isProcessing) {
                                e.target.style.background = 'none';
                                e.target.style.color = '#009e4a';
                            }
                        }}
                    >
                        {isProcessing ? "Sending code..." : "Send code"}
                    </button>
                </form>

                <div style={{ marginTop: "20px" }}>
                    <button
                        onClick={() => navigate("/login")}
                        style={{
                            background: 'none',
                            border: 'none',
                            color: '#009e4a',
                            padding: '8px',
                            cursor: 'pointer',
                            fontFamily: 'CustomFont',
                            fontSize: '14px',
                            textDecoration: 'underline'
                        }}
                    >
                        Back to login
                    </button>
                </div>
            </div>
        </div>
    );
};

export default PasswordlessLoginPage;
